import "./QuoteSection.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuoteLeft } from "@fortawesome/free-solid-svg-icons";

function QuoteSection() {
  return (
    <div className="section quote">
      <p className="qoute-text">
        <FontAwesomeIcon icon={faQuoteLeft} />
        If you really want to make a friend, go to someone’s house and eat with
        him… The people who give you their food give you their heart.
      </p>
      <p className="qoute-auther">– Cesar Chavez</p>
    </div>
  );
}

export default QuoteSection;
